import apiService from './api';
import { Paginacao } from '../types';

export interface UsuarioData {
  id: number;
  name: string;
  email: string;
  role: string;
  empresa_id: number;
  ativo: boolean;
  desativado_em?: string | null;
  created_at: string;
}

export interface RoleInfo {
  value: string;
  label: string;
  descricao: string;
}

export const usuariosService = {
  getAll: async (params: { search?: string; role?: string; page?: number } = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v) query.append(k, String(v));
    });
    return apiService.get<{
      success: boolean;
      data: UsuarioData[];
      pagination?: Paginacao;
    }>(`/v1/usuarios?${query.toString()}`);
  },

  create: async (data: { name: string; email: string; password: string; password_confirmation?: string; role: string }) => {
    return apiService.post<{ success: boolean; message: string; data: UsuarioData }>('/v1/usuarios', data);
  },

  update: async (id: number, data: { name?: string; email?: string; password?: string; password_confirmation?: string; role?: string }) => {
    return apiService.put<{ success: boolean; message: string; data: UsuarioData }>(`/v1/usuarios/${id}`, data);
  },

  remove: async (id: number) => {
    return apiService.delete<{ success: boolean; message: string }>(`/v1/usuarios/${id}`);
  },

  toggleStatus: async (id: number) => {
    return apiService.post<{ success: boolean; message: string; data: UsuarioData }>(`/v1/usuarios/${id}/toggle-status`, {});
  },

  getRoles: async () => {
    return apiService.get<{ success: boolean; data: RoleInfo[] }>('/v1/usuarios/roles');
  },
};
